import WhereEventSystem from "./EventSystem/WhereEventSystem";
import AccountService from "./Services/AccountService";
import AdminService from "./Services/AdminService";
import OrderService from "./Services/OrderService";
import UserService from "./Services/UserService";

const WhereSystem = {
    EventSystem: new WhereEventSystem(),
    Map: {},
    AppConfig: {},

    initApp: function (config) {
        this.AppConfig = config;
        this.updateServices();
        let mySelf = this;

    },
    updateServices: function () {
        this.services.accountService.setControllerPath(`${this.AppConfig.api.url}/account`, this.AppConfig.api.isRelative);
        this.services.adminService.setControllerPath(`${this.AppConfig.api.url}/admin`, this.AppConfig.api.isRelative);
        this.services.orderService.setControllerPath(`${this.AppConfig.api.url}/orders`, this.AppConfig.api.isRelative);
         this.services.userService.setControllerPath(`${this.AppConfig.api.url}/users`, this.AppConfig.api.isRelative);
    },

    services: {
        accountService: new AccountService(),
        orderService: new OrderService(),
        adminService:new AdminService(),
        userService:new UserService()
    }
}

export default WhereSystem;